<div class="container container-shadow">
  <div class="pt-4"></div>
  <h3>
    <small class="float-right">
      <small>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="loadScanPriorities()">
          <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loading }"></i>
        </button>
      </small>
    </small>
    Scan Priorities
  </h3>
  <div class="py-2"></div>
  <table class="table">
    <thead>
      <tr>
        <th>Priority</th>
        <th>Name</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let scanPriority of scanPriorities; let i = index">
        <td>
          <input type="number" min="1" class="form-control" name="priority" ngDefaultControl [(ngModel)]="scanPriority.priority" (keyup)="scanPriority.priorityChanged = true; scanPriority.changed = true" />
        </td>
        <td>
          <input type="text" class="form-control" name="name" ngDefaultControl [(ngModel)]="scanPriority.name" (keyup)="scanPriority.changed = true" />
        </td>
        <td>
          <div class="btn-group btn-group-sm w-100">
            <button type="button" class="btn btn-primary btn-sm w-50" [disabled]="scanPriority.saving || scanPriority.deleting" (click)="save(scanPriority)">
              <i class="fas fa-save fa-fw" [ngClass]="{ 'fa-spin': scanPriority.saving }"></i>
              Save
            </button>
            <button type="button" class="btn btn-danger btn-sm w-50" [disabled]="scanPriority.saving || scanPriority.deleting" (click)="deleteModal(scanPriority, i, delete_scan_priority_modal)">
              <i class="fas fa-trash fa-fw" [ngClass]="{ 'fa-spin': scanPriority.deleting }"></i>
              Delete
            </button>
          </div>
          <br />
          <small class="text-danger" *ngIf="scanPriority.changed">This scan priority has changed and not saved.</small>
        </td>
      </tr>
      <tr>
        <td>
          <input type="number" min="1" placeholder="New scan priority" class="form-control" name="priority" ngDefaultControl [(ngModel)]="newScanPriority.priority" />
        </td>
        <td>
          <input type="text" placeholder="New scan priority" class="form-control" name="name" ngDefaultControl [(ngModel)]="newScanPriority.name" />
        </td>
        <td>
          <div class="btn-group btn-group-sm w-100">
            <button type="button" class="btn btn-primary btn-sm w-100" [disabled]="newScanPriority.saving || newScanPriority.deleting" (click)="save(newScanPriority)">
              <i class="fas fa-save fa-fw" [ngClass]="{ 'fa-spin': newScanPriority.saving }"></i>
              Add New
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="py-5"></div>
</div>
<div class="py-5"></div>
<ng-template #delete_scan_priority_modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-danger">Delete scan priority</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="scanPriorityToDelete">Confirm scan priority ({{ scanPriorityToDelete.priority }} - {{ scanPriorityToDelete.name }}) deletion ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('delete')">Confirm delete</button>
    <button type="button" class="btn btn-outline-secondary" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>
